import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private msalService: MsalService) { }

  /**
   * Retrieve the current authentication state
   * @returns {boolean} True if user is authenticated and false if not
   */
  public isAuthenticated(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }
}
